import React from "react";
import {Box, Typography} from "@mui/material";

export const NotFoundPage = () => {
    return (
        <Box sx={{
            width: `100vw`,
            height: `100vh`,
            display: `flex`,
            alignItems: `center`,
            justifyContent: `center`,
            backgroundColor: `rgb(247,250,252)`,
            direction: `ltr`
        }}>
            <Typography color={`rgb(160,174,192)`} sx={{letterSpacing: `.05em`, pr: `10px`, borderRight: `1px solid rgb(160,174,192)`}} fontSize={`2rem`}>
                404
            </Typography>
            <Typography color={`rgb(160,174,192)`} sx={{letterSpacing: `.05em`, pl: `10px`}} fontSize={`2rem`}>
                Not Found
            </Typography>
        </Box>
    )
}